const TableRows = (props) => {
  return (
    Array.from({ length: props.rows }, (_, i) => (
      <tr key={i} className="shimmer">
        <td colSpan={props.colSpan} ><span style={{ visibility: 'hidden' }}>test</span></td>
      </tr>
    ))
  );

}
const Loader = () => {
  return (
    <div className="loader d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

const NoRecords = (props) => {
  return (

    <div className="noresult" style={{ display: 'block', width: '100%' }}>
      <div className="text-center">
        {/* <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: '75px', height: '75px' }} /> */}
        <img src="/assets/images/no-data.svg" style={{ width: '160px', height: '160px' }}  alt='' />
        <h6 className="mt-2">No Record Found</h6>
      </div>
    </div>
  );
}
export { TableRows, NoRecords, Loader };